// src/data/searchData.js

// Mapa de traducciones: vincula cada path con su clave en i18n
export const translationMap = {
  '/gastos-medicos': 'search.medicalExpenses',
  '/accidentes': 'search.accidents',
  '/vida': 'search.life',
  '/auto': 'search.auto',
  '/viajes': 'search.travel',
  '/hogar': 'search.home',
  '/ahorro': 'search.savings',
  '/mascotas': 'search.pets',
  '/responsabilidad-civil': 'search.civilLiability',
  '/flotillas': 'search.fleets',
  '/seguro-de-vida-colectivo': 'search.collectiveLife',
  '/gastos-medicos-colectivo': 'search.collectiveMedical',
  '/aviacion': 'search.aviation',
  '/embarcaciones': 'search.vessels',
  '/transporte': 'search.transport',
  '/accidentes-colectivo': 'search.collectiveAccidents',
  '/construccion': 'search.construction',
  '/terrorismo': 'search.terrorism',
  '/especiales': 'search.special',
  '/ciberseguridad': 'search.cybersecurity',
  '/fianzas': 'search.bonds',
  '/paquete-empresarial': 'search.businessPackage'
}

export const siteContent = [
  {
    label: 'Gastos médicos',
    path: '/gastos-medicos',
    keywords: 'search.medicalExpensesKeywords'
  },
  {
    label: 'Accidentes',
    path: '/accidentes',
    keywords: 'search.accidentsKeywords'
  },
  {
    label: 'Vida',
    path: '/vida',
    keywords: 'search.lifeKeywords'
  },
  {
    label: 'Auto',
    path: '/auto',
    keywords: 'search.autoKeywords'
  },
  {
    label: 'Viajes',
    path: '/viajes',
    keywords: 'search.travelKeywords'
  },
  {
    label: 'Hogar',
    path: '/hogar',
    keywords: 'search.homeKeywords'
  },
  {
    label: 'Ahorro',
    path: '/ahorro',
    keywords: 'search.savingsKeywords'
  },
  {
    label: 'Mascotas',
    path: '/mascotas',
    keywords: 'search.petsKeywords'
  },
  {
    label: 'Responsabilidad civil',
    path: '/responsabilidad-civil',
    keywords: 'search.civilLiabilityKeywords'
  },
  {
    label: 'Flotillas',
    path: '/flotillas',
    keywords: 'search.fleetsKeywords'
  },
  {
    label: 'Vida Colectiva',
    path: '/seguro-de-vida-colectivo',
    keywords: 'search.collectiveLifeKeywords'
  },
  {
    label: 'Gastos médicos colectivo',
    path: '/gastos-medicos-colectivo',
    keywords: 'search.collectiveMedicalKeywords'
  },
  {
    label: 'Aviación',
    path: '/aviacion',
    keywords: 'search.aviationKeywords'
  },
  {
    label: 'Embarcaciones',
    path: '/embarcaciones',
    keywords: 'search.vesselsKeywords'
  },
  {
    label: 'Transporte',
    path: '/transporte',
    keywords: 'search.transportKeywords'
  },
  {
    label: 'Accidentes Colectivo',
    path: '/accidentes-colectivo',
    keywords: 'search.collectiveAccidentsKeywords'
  },
  {
    label: 'Construcción',
    path: '/construccion',
    keywords: 'search.constructionKeywords'
  },
  {
    label: 'Terrorismo',
    path: '/terrorismo',
    keywords: 'search.terrorismKeywords'
  },
  {
    label: 'Especiales',
    path: '/especiales',
    keywords: 'search.specialKeywords'
  },
  {
    label: 'Ciberseguridad',
    path: '/ciberseguridad',
    keywords: 'search.cybersecurityKeywords'
  },
  {
    label: 'Fianzas',
    path: '/fianzas',
    keywords: 'search.bondsKeywords'
  }
  // {
  //   label: "Paquete empresarial",
  //   path: "/paquete-empresarial",
  //   keywords: "search.businessPackageKeywords",
  // },
  //     "incendios",
  //     "desastres",
  //     "daños",
  //     "negocio",
  //     "protección",
  //     "materiales",
  //     "robo",
  //     "mercancía",
  //     "dinero",
  //     "valores",
  //     "rotura",
  //     "cristales",
  //     "anuncios",
  //     "luminosos",
  //     "calderas",
  //     "responsabilidad",
  //     "civil",
  //     "terceros",
  //     "orientación",
  //     "médica",
  //     "pérdidas",
  //     "inmueble",
  //   ],
  // },
]
